<template lang="pug">
transition(
name="popup"
)
  .button-go(@click="go")
    span 马上出发


</template>

<script>

  import IconMore from 'src/components/vca/widgets/IconMore'
  import {mapMutations} from 'vuex'
  export default {
    name: 'button-more',
    components: {
      IconMore,
    },
    data() {
      return {}
    },
    props: {},
    computed: {},
    mounted() {},
    beforeDestroy() {},
    methods: {
      //...mapMutations('app', ['openMenu'])
      go(){
        this.$emit('go')
      }
    },
    watch: {},
  }
</script>

<style lang="sass" scoped>
  @import "src/styles/common.sass"

  .button-go
    transform-origin: center
    line-height: 0
    //background: greenyellow
    pointer-events: all
    border: #fff 2px solid
    border-radius: 0.38rem
    padding: 0.08rem 0.5rem

    //position: absolute
    //bottom: $ui-margin-top + 0.05rem
    //left: $ui-margin-left + 0.15rem
    display: flex
    align-items: center
    justify-content: center
    span
      margin: 0
      padding: 0
      color: white
      line-height: 0.16rem
      font-size: 0.16rem
      //background: #e15125
  .popup-enter-active
    transition: all 0.7s cubic-bezier(.34,2.4,.71,.94) 1s
  .popup-leave-active
    transition: all 0.7s ease-in-out

  .popup-enter, .popup-leave-to
    transform: translateY(100%) scale(0)
    opacity: 0

  // img
  //   display: block
  //   +center-img()
  //   max-width: 70%
  //   max-height: 70%

</style>
